import { mesasEntradaConstants } from "./constants";

export const mesasEntradaActions = {    
  saveAbogadoExtrajudicial(abogado) {
    return { type: mesasEntradaConstants.ABOGADO_EXTRAJUDICIAL, payload: abogado };
  },
  saveAbogadoJudicial(abogado) {
    return { type: mesasEntradaConstants.ABOGADO_JUDICIAL, payload: abogado };
  },
  saveFilters(filters) {
    return { type: mesasEntradaConstants.SAVE_FILTERS, payload: filters };
  },
  saveMesaExtrajudicial(data) {
    return { type: mesasEntradaConstants.MESA_EXTRAJUDICIAL, payload: data };
  },
  saveMesaJudicial(data) {
    return { type: mesasEntradaConstants.MESA_JUDICIAL, payload: data };
  },
  saveMesaExterna(data) {
    return { type: mesasEntradaConstants.MESA_EXTERNA, payload: data };
  },
  limpiarMesas() {
    return { type: mesasEntradaConstants.LIMPIAR_MESAS };
  },
  fechaInicial(data) {
    return { type: mesasEntradaConstants.FECHA_INICIAL, payload: data  };
  },
};